import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

import common from '@utils/locale/en.json';

export type LanguageType = keyof typeof CONST.i18n.languages;

export const defaultNS = 'common';
export const resources = {
  en: {
    common,
  },
} as const;

i18n
  .use(
    resourcesToBackend((language, namespace, callback) => {
      import(`@utils/locale/${language}.json`)
        .then(res => callback(null, res))
        .catch(error => callback(error, null));
    })
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: CONST.i18n.defaultLang,
    preload: false,
    defaultNS,
    ns: Object.keys(resources.en),
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    returnObjects: true,
    returnNull: false,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
